import $ from 'jquery';
import CartCheckbox from '../ui/cart-checkbox';
import GiftWrap from '../ui/gift-wrap';
import PlusMinus from '../ui/plus-minus';
import {toggle} from '../ui/utilities';

import '../../styles/templates/cart.scss';

/**
 * Cart checkbox
 */
new CartCheckbox('[data-cart-checkbox]');

/**
 * Gift Wrap
 */
new GiftWrap('.js-giftwrap');

/**
 * Plus Minus Fields
 */
$('.js-plus-minus').each((_, item) => {
  new PlusMinus(item);
});

/**
 * Toggles
 */
toggle.bind('.js-note-toggle', '.js-note-content');
